import React, { useContext } from "react";
import { TitleProps, useLink, useRouterContext, useRouterType } from "@refinedev/core";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ColorModeContext } from "../../contexts/color-mode";

export const Title: React.FC<TitleProps> = ({ collapsed }) => {
    const routerType = useRouterType();
    const Link = useLink();
    const { Link: LegacyLink } = useRouterContext();
    const { mode } = useContext(ColorModeContext);

    const ActiveLink = routerType === "legacy" ? LegacyLink : Link;

    // Couleur dynamique selon le mode
    const textColor = mode === "light" ? "#000" : "#fff";

    return (
      <Box className="title-container" sx={{display: "flex", width: "100%", justifyContent: "center"}}>
        <Box sx={{width: "fit-content", borderRadius: "15px", px: 2, py: 1}}>
          <Button variant="text" disableRipple>
              <ActiveLink to="/">
                  <Typography
                    variant="h6"
                    sx={{
                      color: textColor,
                      fontWeight: "bold",
                      letterSpacing: "0.1em",
                      fontSize: collapsed ? "0.5rem" : "1.25rem",
                    }}
                  >
                    SAFEE
                  </Typography>
              </ActiveLink>
          </Button>
        </Box>
      </Box>
    );
};
